<template>
  <tiles-page
    title="Настройки"
    :link-groups="linksGroups"
    sm="12"
    md="6"
    xl="4"
  />
</template>

<script>
  import TilesPage from '@/components/ui/TilesPage.vue'
  import RouteName from '@/models/enums/RouteName'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    components: { TilesPage },
    data () {
      return {
        linksGroups: [
          {
            title: 'Подписка FAKT',
            links: [
              {
                icon: 'crown',
                cols: 6,
                routeName: RouteName.BillingMyTariff,
                title: 'Тариф',
                permissions: [CRMPermission.ManagePaymentAccount],
              },
              {
                icon: 'credit-card',
                cols: 6,
                title: 'Способы оплаты',
                routeName: RouteName.BillingPaymentMethods,
                permissions: [CRMPermission.ManagePaymentAccount],
              },
            ],
          },
          {
            title: 'Оборудование',
            links: [
              {
                icon: 'server',
                cols: 6,
                routeName: RouteName.SettingsKkmServer,
                title: 'ККМ Server',
                permissions: [CRMPermission.KkmServer],
              },
              {
                icon: 'receipt',
                cols: 6,
                routeName: RouteName.SettingsPrintingFiscal,
                title: 'Печать и фискализация',
                permissions: [CRMPermission.PrintingFiscal],
              },
            ],
          },
          {
            title: 'Система',
            links: [
              {
                icon: 'clipboard-list',
                cols: 12,
                routeName: RouteName.SettingsOrders,
                title: 'Заказы',
                permissions: [CRMPermission.SettingsOrders],
              },
            ],
          },
          {
            title: 'Отзывы',
            links: [
              {
                icon: 'star',
                cols: 12,
                routeName: RouteName.SettingsReviewActions,
                title: 'Внешние сервисы для отзывов',
                permissions: [CRMPermission.ReviewActions],
              },
              /* {
                icon: 'qrcode',
                cols: 6,
                routeName: RouteName.SettingsQrFeedback,
                title: 'Отзывы на чеках (QR)',
                permissions: [CRMPermission.QrFeedback],
              }, */
            ],
          },
          {
            title: 'Юридическая информация',
            links: [
              {
                icon: 'file-signature',
                cols: 12,
                routeName: RouteName.LegalInfoPages,
                title: 'Информация для сайта',
                permissions: [CRMPermission.LegalInfoPagesEdit],
              },
            ],
          },
          {
            title: 'Источники',
            links: [
              {
                icon: 'broadcast-tower',
                routeName: RouteName.Sources,
                title: 'Источники',
                permissions: [CRMPermission.Sources],
              },
              {
                icon: 'plug',
                routeName: RouteName.Connectors,
                title: 'Коннекторы',
                permissions: [CRMPermission.Connectors],
              },
            ],
          },
          {
            title: 'Сайт',
            links: [
              {
                icon: 'globe',
                soon: true,
                title: 'Общие настройки',
                permissions: [CRMPermission.SiteGeneral],
              },
              {
                icon: 'search-plus',
                routeName: RouteName.SeoPageMetaList,
                title: 'SEO настройки',
                permissions: [CRMPermission.Seo],
              },
            ],
          },
          {
            title: 'Оплата и приём заказов',
            links: [
              {
                icon: 'credit-card',
                soon: true,
                title: 'Способы оплаты',
                permissions: [CRMPermission.PaymentTypes],
                cols: 6,
              },
              {
                icon: 'wallet',
                routeName: RouteName.SettingsPaymentMethods,
                title: 'Методы оплаты',
                permissions: [CRMPermission.PaymentMethods],
                cols: 6,
              },
            ],
          },
          {
            title: 'Доступы',
            links: [
              {
                icon: 'shield-alt',
                soon: true,
                title: 'Права доступа',
                permissions: [CRMPermission.AccessRights],
              },
            ],
          },
          {
            title: 'Уведомления и рассылки',
            links: [
              {
                icon: 'sms',
                cols: 6,
                soon: true,
                title: 'SMS-провайдер',
                permissions: [CRMPermission.SmsProvider],
              },
              {
                icon: 'envelope',
                cols: 6,
                soon: true,
                title: 'Email-провайдер',
                permissions: [CRMPermission.EmailProvider],
              },
              {
                icon: 'certificate',
                cols: 12,
                soon: true,
                title: 'Push-сертификаты',
                permissions: [CRMPermission.PushCertificates],
              },
            ],
          },
          {
            title: 'Агрегаторы',
            links: [
              {
                icon: 'share-alt',
                soon: true,
                title: 'Настройки интеграции',
                permissions: [CRMPermission.Aggregators],
              },
            ],
          },
          {
            title: 'Мобильное приложение',
            links: [
              {
                icon: 'mobile-alt',
                soon: true,
                title: 'Настройки App',
                permissions: [CRMPermission.MobileApp],
              },
              {
                icon: 'bell',
                soon: true,
                title: 'Push-уведомления',
                permissions: [CRMPermission.MobilePush],
              },
            ],
          },
          {
            title: 'Интеграции',
            links: [
              {
                icon: 'fab fa-telegram',
                soon: true,
                title: 'Telegram-бот',
                permissions: [CRMPermission.TelegramBot],
              },
              {
                icon: 'external-link-alt',
                soon: true,
                title: 'Внешние',
                permissions: [CRMPermission.External],
              },
            ],
          },
          {
            title: 'Персонал',
            links: [
              {
                icon: 'users',
                cols: 12,
                routeName: RouteName.Staff,
                title: 'Сотрудники',
                permissions: [CRMPermission.ViewUsers],
              },
            ],
          },
        ],
      }
    },
  }
</script>
